import { constants } from '../utils'
import base from './base'

const { headers, url, request } = base

const getRenewEnrollmentHistory = async group_student_id => {
  return request(url(constants.api.renewEnrollmentHistory.get(group_student_id)), {
    method: 'GET',
    headers: headers(),
  })
}

const renewEnrollmentHistoryApi = {
  getRenewEnrollmentHistory,
}

export default renewEnrollmentHistoryApi
